import { useTranslation } from 'react-i18next';
import GroupsIcon from '@mui/icons-material/Groups';
import { Box } from '@mui/material';
import ListOfClubs from './ListOfClubs';
import { club } from 'apis';
import { useQuery } from 'react-query';
import { useEffect, useRef, useState } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { any } from 'prop-types';

const containerStyle = {
    width: '100%',
    height: '100%',
};

const LeafletMap = () => {
    const { t } = useTranslation();

    const [positions, setPositions] = useState<any[]>([]);
    const [selectedPosition, setSelectedPosition] = useState<{ lat: number; lng: number } | null>(null);
    const [activeMarker, setActiveMarker] = useState<number | null>(null);
    const mapRef = useRef<google.maps.Map | null>(null);

    const { data: clubsData } = useQuery(
        'geolocation',
        async () => {
            const res = await club.getClubsPublic();
            return res;
        },
        { suspense: false }
    );

    useEffect(() => {
        if (clubsData) {
            const mappedPositions: any[] = clubsData
                .filter((club: any) => club.latitude !== null && club.longitude !== null)
                .map((club: any) => ({
                    id: club.id,
                    lat: club.latitude!,
                    lng: club.longitude!,
                    popupText: club.title,
                    address1: club.address1!
                }));

            setPositions(mappedPositions);
        }
    }, [clubsData]);

    //When a user clicks a pin again, gmaps rezooms
    useEffect(() => {
        if (selectedPosition && mapRef.current) {
            mapRef.current.panTo(selectedPosition);
            mapRef.current.setZoom(15);
        }
    }, [selectedPosition]);

    const clubs = (clubsData || []).map((club: any) => ({
        icon: <GroupsIcon fontSize="small" />,
        title: club.title,
        address1: club.address1,
        description: `Club ID: ${club.id}`,
        lat: club.latitude!,
        lng: club.longitude!,
        regionName: club.regionName!,
        regionalUnitName: club.regionalUnitName!
    }));

    const handleClick = (title: string, lat: number | any, lng: number | any) => {
        if (lat !== null && lng !== null) {
            setSelectedPosition({ lat, lng });
        }
    };

    const handleMapLoad = (map: google.maps.Map) => {
        mapRef.current = map;
    };

    return (
        <Box sx={{ display: 'flex', height: '100%', width: '100%' }}>
            <ListOfClubs clubs={clubs} handleClick={(title, lat, lng) => handleClick(title, lat, lng)} t={t}></ListOfClubs>

            <Box sx={{ flex: 1, height: '100%' }}>
                <LoadScript googleMapsApiKey={JSON.parse(localStorage.getItem('CONFIG') ?? '').VITE_GOOGLE_MAPS_API_KEY}>
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={selectedPosition || { lat: 37.99, lng: 23.697 }}
                        zoom={selectedPosition ? 15 : 7}
                        onLoad={handleMapLoad}
                    >
                        {positions.map((position) => (
                            <Marker
                                key={position.id}
                                position={{ lat: position.lat, lng: position.lng }}
                                onClick={() => setActiveMarker(position.id)}
                            >
                                {activeMarker === position.id && (
                                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                        <div>
                                            <strong>{position.popupText}</strong>
                                            <p>{position.address1}</p>
                                        </div>
                                    </InfoWindow>
                                )}
                            </Marker>
                        ))}
                    </GoogleMap>
                </LoadScript>
            </Box>
        </Box>
    );
};

export default LeafletMap;
